module.exports = __webpack_public_path__ + "static/media/coins.c1498575.svg";